export interface FirebaseConfigEnv {
  REACT_APP_FIREBASE_API_KEY?: string;
  REACT_APP_FIREBASE_AUTH_DOMAIN?: string;
  REACT_APP_FIREBASE_PROJECT_ID?: string;
  REACT_APP_FIREBASE_STORAGE_BUCKET?: string;
  REACT_APP_FIREBASE_MESSAGING_SENDER_ID?: string;
  REACT_APP_FIREBASE_APP_ID?: string;
  REACT_APP_AUTH_EMULATOR_PORT?: string;
  REACT_APP_FIRESTORE_EMULATOR_PORT?: string;
  REACT_APP_STORAGE_EMULATOR_PORT?: string;
  [key: string]: string | undefined;
}

function defaultAuthDomain(projectId?: string): string | undefined {
  return projectId ? `${projectId}.firebaseapp.com` : undefined;
}

// The React app is served at beta.alignedhq.ai but shares the prod project's
// Auth (so it must use the same auth domain the OAuth providers are configured
// against). Map project id → canonical auth domain. See docs/03-gcp-firebase-setup.md.
const CANONICAL_AUTH_DOMAINS: Record<string, string> = {
  'teachers-assistant-web': 'app.alignedhq.ai',
};

export function resolveAuthDomain(
  configuredAuthDomain: string | undefined,
  projectId: string | undefined,
  hostname: string | undefined,
): string | undefined {
  if (!hostname || hostname === 'localhost' || hostname === '127.0.0.1') {
    return configuredAuthDomain ?? defaultAuthDomain(projectId);
  }

  if (projectId && CANONICAL_AUTH_DOMAINS[projectId]) {
    return CANONICAL_AUTH_DOMAINS[projectId];
  }

  return configuredAuthDomain ?? defaultAuthDomain(projectId);
}

export function buildFirebaseConfig(env: FirebaseConfigEnv, hostname: string | undefined) {
  return {
    apiKey: env.REACT_APP_FIREBASE_API_KEY,
    authDomain: resolveAuthDomain(env.REACT_APP_FIREBASE_AUTH_DOMAIN, env.REACT_APP_FIREBASE_PROJECT_ID, hostname),
    projectId: env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: env.REACT_APP_FIREBASE_APP_ID,
  };
}

export function resolveEmulatorPort(value: string | undefined, fallback = 8080): number {
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 && parsed <= 65_535 ? parsed : fallback;
}
